import DaytonaSwitch from './DaytonaSwitch'

export default DaytonaSwitch
// eslint-disable-next-line import/export
export * from './DaytonaSwitch'
